/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Newsletter_PlaceholderInputs */

const en_directory_home_newsletter_placeholder = /** @type {(inputs: Directory_Home_Newsletter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const zh_directory_home_newsletter_placeholder = /** @type {(inputs: Directory_Home_Newsletter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

/**
* | output |
* | --- |
* | "you@example.com" |
*
* @param {Directory_Home_Newsletter_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_newsletter_placeholder = /** @type {((inputs?: Directory_Home_Newsletter_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Newsletter_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_newsletter_placeholder(inputs)
	return zh_directory_home_newsletter_placeholder(inputs)
});
export { directory_home_newsletter_placeholder as "directory.home.newsletter_placeholder" }